/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "./theme/ThemeProvider";
import Dashboard from "./pages/Dashboard";
import Order from "./pages/Order"
import AllProducts from "./pages/AllProducts"
import Stock from "./pages/Stock"
import Divisions from "./pages/Divisions"
import Categories from "./pages/Categories";
import Customers from "./pages/Customers"
import CustomerDetailsPage from "./pages/Customers/CustomerDetails"

import Banner from "./pages/Banner"
import Theme from "./pages/Theme"
import StoreSettings from "./pages/StoreSettings"
import Coupons from "./pages/Coupons"
import ActivityLog from "./pages/ActivityLog"
import Subscriptions from "./pages/Subscription"
import Payments from "./pages/PaymentMethods"
import Shipping from "./pages/DeliveryCompanies";
import Invoice from "./pages/InvoiceSettings"
import Employees from "./pages/EmployeesPage"
import Notifications from "./pages/Notifications"
import Analytics from "./pages/Reports/Analytics"
import SalesReport from "./pages/Reports/SalesReport"
import InventoryReport from "./pages/Reports/InventoryReport"
import CustomerReport from "./pages/Reports/CustomerReport"
import ProductReport from "./pages/Reports/ProductReport"
import OrderDetails from "./pages/Orders/OrderDetails"
import Reviews from "./pages/Reviews"
import ProfileSettings from "./pages/ProfileSettings"
import ManualOrdersPage from "./pages/Orders/ManualOrdersPage"
import CreateOrderPage from "./pages/Orders/CreateOrderPage"
import PrintInvoice from "./pages/Orders/PrintInvoice"
import ProductDetails from "./pages/ProductDetails"
import ProductMovement from "./pages/ProductMovement"
import OrdersReports from "./pages/Reports/OrdersReports"

export default function AdminStoreApp() {
  return (
    <ThemeProvider>
      <Routes>
        <Route path="/" element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="orders" element={<Order />} />
        <Route path="/orders-details/:orderId" element={<OrderDetails />} />
        <Route path="/orders/invoice/:orderId" element={<PrintInvoice />} />
        <Route path="products" element={<AllProducts />} />
        <Route path="stock" element={<Stock />} />
        <Route path="divisions" element={<Divisions />} />
        <Route path="categories" element={<Categories />} />
        <Route path="customers" element={<Customers />} />
        <Route path="customers/details/:customerName" element={<CustomerDetailsPage />} />

        <Route path="store/banners" element={<Banner />} />
        <Route path="store/theme" element={<Theme />} />
        <Route path="store/settings" element={<StoreSettings />} />
        <Route path="/marketing/coupons" element={<Coupons />} />
        <Route path="activity" element={<ActivityLog />} />
        <Route path="subscriptions" element={<Subscriptions />} />
        <Route path="settings/payments" element={<Payments />} />
        <Route path="settings/shipping" element={<Shipping />} />
        <Route path="/settings/invoice" element={<Invoice />} />
        <Route path="reports/analytics" element={<Analytics />} />
        <Route path="reports/sales" element={<SalesReport />} />
        <Route path="reports/inventory" element={<InventoryReport />} />
        <Route path="reports/customers" element={<CustomerReport />} />
        <Route path="reports/products" element={<ProductReport />} />
        <Route path="reports/orders" element={<OrdersReports />} />
        <Route path="employees" element={<Employees />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="store-reviews" element={<Reviews />} />
        <Route path="profile-settings" element={<ProfileSettings />} />
        <Route path="manual-orders" element={<ManualOrdersPage />} />
        <Route path="orders/create" element={<CreateOrderPage />} />
        <Route path="products/details/:itemId" element={<ProductDetails />} />
        <Route path="products/movement/:itemId" element={<ProductMovement />} />
      </Routes>
    </ThemeProvider>
  );
}
